import axios from 'axios'
import { getHost } from './host'

export interface Report {
  report_id: number;
  report_schedule_id: number;
  template_id: number;
  customer_id: number;
  requester_user_id: number;
  account_id: number;
  monitor_id: number;
  station_id: number;
  recipients: number[];
  period: string;
  start: string;
  end: string;
  status: number;
  uri: string;
  created: string;
  updated: string;
}

export async function getReports(api_key: string, station_id: number) {
  const url = `https://${getHost()}/api/reports`
  
  const params = {
    station_id: station_id
  }

  const { data } = await axios.get<{ data: Report[] }>(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  
  return data.data
}

export async function getPositionsReports(api_key: string, stations: string[]) {
  const url = `https://${getHost()}/api/reports`
  
  const params = {
    stations: stations
  }

  const { data } = await axios.get<{ data: Report[] }>(
    url, 
    { 
      headers: {'X-API-KEY': api_key, Accept: 'application/json'},
      params: params
    }
  );
  
  return data.data
}